import { createRoutine } from 'redux-saga-routines';
import dotProp from 'dot-prop-immutable';
import { createSelector } from 'reselect';
import { map, find } from 'lodash';

export const routines = {
  getCurrentUser: createRoutine('GET_CURRENT_USER'),
  getUsers: createRoutine('GET_USERS')
};

const initialState = {
  currentUser: {},
  loggedInUser: {},
  users: [],
  isLoading: false,
  isUsersLoading: false
};

function reducer(state = initialState, { type, payload }) {
  let nextState = state;
  switch (type) {
    case routines.getCurrentUser.TRIGGER:
      nextState = dotProp.set(nextState, 'isLoading', true);
      break;
    case routines.getCurrentUser.SUCCESS:
      nextState = dotProp.set(nextState, 'isLoading', false);
      nextState = dotProp.set(nextState, 'currentUser', payload.currentUser);
      nextState = dotProp.set(nextState, 'loggedInUser', payload.loggedInUser);
      break;
    case routines.getCurrentUser.FAILURE:
      nextState = dotProp.set(nextState, 'isLoading', false);
      break;
    case routines.getUsers.TRIGGER:
      nextState = dotProp.set(nextState, 'isUsersLoading', true);
      break;
    case routines.getUsers.SUCCESS:
      nextState = dotProp.set(nextState, 'isUsersLoading', false);
      nextState = dotProp.set(nextState, 'users', payload);
      break;
    case routines.getUsers.FAILURE:
      nextState = dotProp.set(nextState, 'isUsersLoading', false);
      break;
    default:
      break;
  }
  return nextState;
}

export const isLoadingSelector = state => state.db.users.isLoading;
export const isUsersLoadingSelector = state => state.db.users.isUsersLoading;
export const currentUserSelector = state => state.db.users.currentUser;
export const loggedInUserSelector = state => state.db.users.loggedInUser;
export const usersSelector = state => state.db.users.users;

const currentClientIdSelector = () => {
  const clientId = localStorage.getItem('clientId');
  return clientId ? parseInt(clientId, 10) : null;
};

export const activeUserIdSelector = createSelector(
  [currentUserSelector],
  currentUser => {
    const userId = localStorage.getItem('active-user-id');
    return userId ? parseInt(userId, 10) : currentUser.userId;
  }
);

export const currentClientSelector = createSelector(
  [currentClientIdSelector, currentUserSelector],
  (clientId, { clients = [] }) => {
    return find(clients, client => client.clientId === clientId);
  }
);

export const participantOptionsSelector = createSelector(
  [currentUserSelector, currentClientIdSelector],
  ({ clients = [] }, clientId) => {
    const client = find(clients, client => client.clientId === clientId);
    if (!client) return [];
    return map(client.participants, item => ({
      value: item.participantId,
      label: item.name
    }));
  }
);

export default reducer;
